

/**
 * The codename of the project.
 */
export const PROJECT = 'jupiter';
/**
 * The purchased domain to use.
 */
export const DOMAIN = 'jupiter-esnitalia.click'; // TODO change to your domain
/**
 * An additional custom domain to use.
 */
export const PROD_CUSTOM_DOMAIN: string | null = null; // in case of first creation, use: `null`

export const parameters: Parameters = {
  project: PROJECT,
  apiDomain: 'api.'.concat(DOMAIN),
  webSocketApiDomain: 'socket.'.concat(DOMAIN),
  mediaDomain: 'media.'.concat(DOMAIN),
  frontEndCertificateARN: PROD_CUSTOM_DOMAIN
    ? 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx' // TODO ADD ARN FOR CUSTOM DOMAIN CERTIFICATE
    : undefined,
  firstAdminEmail: 'fillo.bertoncelli@gmail.com', // TODO SET AS EMAIL OF ADMIN
  sesEmail: 'no-reply@'.concat(DOMAIN),
  emailFromName: 'Jupiter App',
  firstSectionName: 'ESN Star Wars',
  firstSectionAlias: 'starwars'
};



export interface Parameters {
  /**
   * Project key (unique to the AWS account).
   */
  project: string;
  /**
   * HTTP API for each environment will be available at `${apiDomain}/${env.stage}`.
   */
  apiDomain: string;
  /**
   * Web Socket API for each environment will be available at `${apiDomain}/${env.stage}`.
   */
  webSocketApiDomain: string;
  /**
   * The domain name where to reach the front-end's media files.
   */
  mediaDomain: string;
  /**
   * The custom front-end certificate ARN to use, to support alternative domains.
   */
  frontEndCertificateARN?: string;

  /**
   * email of the first user
   */
  firstAdminEmail: string;
  /**
   * email address to be used for emails
   */
  sesEmail: string;
  /**
   * name of the sender
   */
  emailFromName: string;
  /**
   * first section name
   */
  firstSectionName: string;
  /**
   * first section alias
   */
  firstSectionAlias: string;
}
